import * as z from 'zod'
import {buildEntrySchemaFor} from '../entry'

export const PrimerComponentAnchorLinkSchema = buildEntrySchemaFor('primerComponentAnchorLink', {
  fields: z.lazy(() =>
    z.object({
      href: z.string(),
      text: z.string(),
      ariaLabel: z.string().optional(),
    }),
  ),
})

export type PrimerComponentAnchorLink = z.infer<typeof PrimerComponentAnchorLinkSchema>
